import React from 'react';
import { ProgressBarContent, ProgressBarWrapper } from './ProgressBar.styled';

interface ProgressBarProps {
  progress: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress = 0 }) => {
  return (
    <ProgressBarWrapper data-testId="progressContainer">
      <ProgressBarContent
        data-testId="progressBar"
        style={{
          width: `${progress}%`,
        }}
      ></ProgressBarContent>
    </ProgressBarWrapper>
  );
};
